import { useIndependentContractorBadgeRevamp } from "./hooks/useIndependentContractorBadgeRevamp";
import { IndependentContractorBadgePageV1 } from "./PageV1";
import { IndependentContractorBadgePageV2 } from "./PageV2";

export function IndependentContractorBadgePage() {
  const { isEnabled } = useIndependentContractorBadgeRevamp();

  if (isEnabled) {
    return <IndependentContractorBadgePageV2 />;
  }

  return <IndependentContractorBadgePageV1 />;
}
